import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { useTranslation } from "react-i18next";
import { ReportViewerRankingListProps } from "../types";

export function ReportViewerRankingList({
  data,
}: ReportViewerRankingListProps) {
  const [translate] = useTranslation(["insights"]);

  const positionColor = (position: number) => {
    switch (position) {
      case 1:
        return "bg-primary-500";
      case 2:
        return "bg-complementary2-500";
      case 3:
        return "bg-complementary4-500";
      case 4:
        return "bg-complementary-500";
      default:
        return "bg-warning-500";
    }
  };

  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-blue-600">📈</span>
          {translate("report-viewer-ranking-list-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {data.map((space) => (
            <div
              key={space.position}
              className="flex items-center justify-between p-3 bg-secondary rounded-lg"
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-neutral-950 font-bold ${positionColor(space.position)}`}
                >
                  {space.position}°
                </div>
                <div>
                  <p className="font-medium">{space.name}</p>
                  <p className="text-sm text-gray-600">{space.location}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-bold text-lg">{space.reservations}</p>
                <p className="text-sm text-gray-600">reservas</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
